import { render, staticRenderFns } from "./OrderStyles.vue?vue&type=template&id=4ebfb3a0&scoped=true"
import script from "./OrderStyles.vue?vue&type=script&lang=ts"
export * from "./OrderStyles.vue?vue&type=script&lang=ts"
import style0 from "./OrderStyles.vue?vue&type=style&index=0&id=4ebfb3a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebfb3a0",
  null
  
)

export default component.exports